// utils/filterProductsUtils.js
export const filterHandlers = {
  boolean: (products, filterName, filterValue) =>
    filterValue
      ? products.filter(product =>
        product.attributes.some(attr => attr.title === filterName && attr.value === "1") ||
        product[filterName] === "1"
      )
      : products,

  // Combine 'number-slider' and 'number-input' types
  "number-range": (products, filterName, filterValue) =>
    products.filter(product => {
      const productValue = product[filterName];
      const isInRange = productValue >= filterValue[0] && productValue <= filterValue[1];
      const hasAttributeInRange = product.attributes.some(attr =>
        attr.title === filterName && attr.value >= filterValue[0] && attr.value <= filterValue[1]
      );
      return isInRange || hasAttributeInRange;
    }),

  default: (products, filterName, filterValue) =>
    products.filter(product =>
      product.attributes.some(attr => attr.name === filterName && attr.value === filterValue) ||
      product[filterName] === filterValue
    ),
};
